var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromotionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1142",
    "data-name": "Rectangle 1142",
    width: 15,
    height: 15,
    transform: "translate(-0.001 0)",
    fill: "#faf8f8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15352",
    "data-name": "Group 15352",
    transform: "translate(1.906 2.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3345",
    "data-name": "Group 3345",
    transform: "translate(-1.905 -2.43)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10991",
    "data-name": "Path 10991",
    d: "M9.129,2.519a.945.945,0,1,1-.945.945.945.945,0,0,1,.945-.945M.552,5.486l5.3-5.3A.637.637,0,0,1,6.3,0h5.668a.631.631,0,0,1,.63.63V6.3a.637.637,0,0,1-.182.448l-5.3,5.3a1.89,1.89,0,0,1-2.669,0L.552,8.186a1.89,1.89,0,0,1,0-2.669ZM1.44,7.261l3.892,3.884a.631.631,0,0,0,.888,0l5.114-5.106V1.259H6.554L1.44,6.373a.632.632,0,0,0,0,.888",
    transform: "translate(1.39 0.909)",
    fill: "#faf8f8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionIcon);
export default __webpack_public_path__ + "static/media/promotion-icon.5aad69319ae6b896340d1a95210d8896.svg";
export { ForwardRef as ReactComponent };